<script>
  import Vue from 'vue';
  import { EventBus } from '@/services/event-bus-service';

  /* eslint-disable no-use-before-define */
  export default Vue.extend({
    functional: true,
    render(h, { children, props }) {
      let refId = props.refId || '';
      let observer = null;
      let scrollObservable = null;

      const setupIntersectionObserver = async () => {
        observer = new IntersectionObserver(([entry]) => {
          if (entry && entry.isIntersecting) {
            observer.disconnect();
            children[0].context.$emit('elementInViewport');
          }
        });
        await children[0].context.$nextTick();
        const observable = document.getElementById(refId);
        observable && observer.observe(observable);
      };

      const throttle = (func, wait = 100) => {
        let timer = null;
        return (...args) => {
          if (timer === null) {
            timer = setTimeout(() => {
              func.apply(this, args);
              timer = null;
            }, wait);
          }
        };
      };

      const isInViewport = (elem) => {
        const bounding = elem.getBoundingClientRect();
        return (
          bounding.top >= 0 &&
          bounding.left >= 0 &&
          bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
      };

      const scrollEventHandler = () => {
        if (isInViewport(scrollObservable)) {
          unregisterScrollEventHandler();
          children[0].context.$emit('elementInViewport');
        }
      };

      const throttledScrollEventHandler = throttle(scrollEventHandler);

      const unregisterScrollEventHandler = () => {
        scrollObservable = null;
        document.removeEventListener('scroll', throttledScrollEventHandler);
      };


      const setupScrollEventHandler = async () => {
        await children[0].context.$nextTick();
        scrollObservable = document.getElementById(refId);
        document.addEventListener('scroll', throttledScrollEventHandler);
      };

      const destroy = () => {
        if (observer) {
          observer.disconnect();
          observer = null;
        } else {
          unregisterScrollEventHandler();
        }
      };

      /**
       * start/stop observing
       * @type {(disable:boolean)=>void}
       */
      const observeHandler = (disable) => {
        if (disable) {
          destroy();
          return;
        }
        if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window) {
          setupIntersectionObserver();
        } else {
          setupScrollEventHandler();
        }
      };

      EventBus.$on('toggleObserving', observeHandler);

      // children[0].context.$root.$on('elementLeave', async (el) => {
      //   let obs = document.getElementById(refId);
      //   if (obs && el === obs.parentElement.parentElement) {
      //     obs.scrollIntoView();
      //     await new Promise(resolve => setTimeout(resolve, 5));

      //     el.parentElement.scrollIntoView();
      //   }
      // });

      children[0].context.$once('hook:destroyed', () => {
        EventBus.$off('toggleObserving', observeHandler);
        destroy();
      });
      children[0].componentOptions.propsData.refId = refId;

      return children;
    },
  });
</script>
